<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" sm="12" md="3" lg="3">
          <v-card flat class="py-3 px-3">
            <v-row>
              <v-col colw="12">
                <h3>Agencies</h3>
              </v-col>
              <v-col cols="12" class="hidden-sm-and-down">
                <v-list class="py-0">
                  <v-list-item-group>
                    <v-list-item
                      @click="menuActionClick('activeAgencies')"
                      dense
                    >
                      <v-list-item-icon>
                        <v-icon color="danetest">mdi-account-multiple</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="danetest--text"
                          >Active Agencies</v-list-item-title
                        >
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      @click="menuActionClick('InactiveAgencies')"
                      dense
                    >
                      <v-list-item-icon>
                        <v-icon color="danetest">mdi-account-remove</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="danetest--text"
                          >Inactive Agencies</v-list-item-title
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>
              <v-col cols="12" class="py-0 hidden-sm-and-up">
                <v-select
                  v-model="selectedItem"
                  @change="menuActionClick(selectedItem)"
                  :items="viewItems"
                  label="Select Items To View"
                  item-text="name"
                  item-value="action"
                ></v-select>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col
          v-if="selectedAgency == '' && activeAgencies"
          cols="12"
          sm="12"
          md="9"
          lg="9"
        >
          <generalAlert
            v-if="alert"
            :alert="alert"
            :alertType="alertType"
            :message="successResponse"
          />
          <v-card flat class="py-3 px-3">
            <v-row>
              <v-col cols="12">
                <h3>Active Agencies</h3>
              </v-col>
              <v-col cols="12">
                <v-card class="py-3 px-3">
                  <v-card-title>
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search Clients"
                      single-line
                      hide-details
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <newAgency @eventname="successAlert" />
                  </v-card-title>
                  <!-- {{ activeAcencies }} -->
                  <v-data-table
                    :headers="headers"
                    :items="activeAcencies"
                    :search="search"
                    :items-per-page="5"
                    :loading="loadingAgencies"
                    loading-text="Loading... Please wait"
                  >
                    <template v-slot:[`item.isActive`]="{ item }">
                      <p v-if="item.isActive == true" class="mb-0">Active</p>
                    </template>
                    <template v-slot:[`item.dateCreate`]="{ item }">
                      {{ item.dateCreate | formatDate }}
                      <!-- {{ item.pageNames.map(page => page.name).join(', ') }} -->
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <v-btn @click="viewAgency(item)" icon color="primary"
                        ><v-icon>mdi-eye</v-icon></v-btn
                      >
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col
          v-if="selectedAgency == '' && InactiveAgencies"
          cols="12"
          sm="12"
          md="9"
          lg="9"
        >
          <v-card flat class="py-3 px-3">
            <v-row>
              <v-col cols="12">
                <h3>Inactive Agencies</h3>
              </v-col>
              <v-col cols="12">
                <v-card class="py-3 px-3">
                  <v-card-title>
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search Clients"
                      single-line
                      hide-details
                    ></v-text-field>
                    <!-- <v-spacer></v-spacer> -->
                    <!-- <newSubscription v-if="columnSize == 8" /> -->
                  </v-card-title>
                  <!-- <v-data-table :headers="headers" :items="activeSubscriptionsList" :search="search"
                                            :items-per-page="5" :loading="isLoading" loading-text="Loading... Please wait">
                                            <template v-slot:[`item.pageNames`]="{ item }">
                                                {{ item.pageNames.map(page => page.name).join(', ') }}
                                            </template>
                                            <template v-slot:[`item.action`]="{ item }">
                                                <v-btn @click="viewSubscription(item)" icon
                                                    color="primary"><v-icon>mdi-eye</v-icon></v-btn>
                                            </template>
                                        </v-data-table> -->
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import newAgency from "@/components/dialogs/newAgency.vue";
import generalAlert from "@/components/alerts/generalAlert.vue";
const moment = require("moment-timezone");

import { firebaseApp } from "../firebaseConfig";
const db = getFirestore(firebaseApp);
import { collection, getDocs, getFirestore } from "firebase/firestore";
export default {
  components: {
    newAgency,
    generalAlert,
  },
  data: () => ({
    selectedItem: "",
    search: "",
    activeAgencies: true,
    InactiveAgencies: false,
    selectedAgency: [],
    activeAcencies: [],
    successResponse: "",
    alertType: "",
    alert: false,
    loadingAgencies: "",
    headers: [
      {
        text: "Acency Name",
        sortable: false,
        value: "agencyName",
        align: "center",
      },
      {
        text: "Contact Person",
        sortable: false,
        value: "agencyContactPersonName",
        align: "center",
      },
      {
        text: "Email Address",
        sortable: false,
        value: "agencyContactPersonEmail",
        align: "center",
      },
      {
        text: "Date Created",
        sortable: false,
        value: "dateCreate",
        align: "center",
      },
      {
        text: "Status",
        sortable: false,
        value: "isActive",
        align: "center",
      },
      {
        text: "Action",
        sortable: false,
        value: "action",
        align: "center",
      },
    ],
    viewItems: [
      { name: "Active Agencies", action: "activeAgencies" },
      { name: "Inactive Agencies", action: "InactiveAgencies" },
      // { name: "Demo Reports", action: 'activeDemoReports' },
    ],
  }),
  filters: {
    formatDate: function (value) {
      return moment(value).format("dddd, MMMM Do YYYY");
    },
  },
  created() {
    this.getAllAgencies();
  },
  methods: {
    async getAllAgencies() {
      this.loadingAgencies = true;
      this.activeAcencies = [];
      try {
        const querySnapshot = await getDocs(collection(db, "agencies"));
        querySnapshot.forEach((doc) => {
          this.activeAcencies.push(doc.data());
        });
        this.loadingAgencies = false;
      } catch (error) {
        console.log(error);
      }
    },
    menuActionClick(action) {
      if (action == "activeAgencies") {
        this.activeAgencies = true;
        this.InactiveAgencies = false;
        this.selectedAgency = [];
      } else if (action == "InactiveAgencies") {
        this.InactiveAgencies = true;
        this.activeAgencies = false;
        this.selectedAgency = [];
      }
    },
    successAlert(message, typeOfAlert) {
      this.successResponse = message;
      this.alertType = typeOfAlert;
      this.alert = true;

      setTimeout(() => {
        this.getAllAgencies();
        this.alert = false;
      }, 5000);
    },
    viewAgency(item) {
      this.$router.push({
        name: "singleAgency",
        params: {
          id: item.agencyId,
        },
      });
    },
  },
};
</script>
